import React, { useState, useEffect,useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import './Workflow_Step_Definition_S.css';

const Workflow_Step_Definition_S = (props) => {
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();
  let selectedData ="";
  
  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };



  

  useEffect(() => {
    document.title = "SRWAE | "+t('Workflow Step Definition');  

 const handleReturn = async () => {
    const collectClientInfo = () => {
      return {
        userAgent: navigator.userAgent,
        language: navigator.language,
        platform: navigator.platform,
        screenResolution: `${screen.width}x${screen.height}`,
        colorDepth: screen.colorDepth,
        timezoneOffset: new Date().getTimezoneOffset(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        cookieEnabled: navigator.cookieEnabled,
        javaEnabled: navigator.javaEnabled(),
        online: navigator.onLine,
        referrer: document.referrer,
        locationHref: window.location.href,
        screenOrientation: screen.orientation?.type || 'unknown'
      };
    };

    const clientInfo = collectClientInfo();

    try {
      const response = await fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/WORKFLOW_STEP_DEFINITION/Select', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: App_Data.Data, clientInfo: clientInfo, stamp: Date.now() })
      });

      if (response.ok) {
        navigate('/Workflow_Step_Definition', { replace: true });
      } else {
        console.error("Select call failed with status:", response.status);
      }
    } catch (err) {
      console.error("Select fetch error:", err);
    }
  };	  
	  
	for (let i = 1; i <= 1; i++) {
	  const sectionId = `#PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_${i}_SECTION`;
	  const headerId = `#PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [1];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
	
	const searchInput = $('input[type="search"]');
 	const Temp_Search = App_Data["Object_Search"];
	if(Temp_Search!=""){
		searchInput.val(Temp_Search);
	}

	if(location.hash=="#Return"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};
		
		const clientInfo = collectClientInfo();

		fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/WORKFLOW_STEP_DEFINITION/Select', {
		  method: 'POST',
		  headers: { 'Content-Type': 'application/json' },
		  body: JSON.stringify({ data:(App_Data&&App_Data.Data?App_Data.Data:{id:-1}) , clientInfo:clientInfo , stamp: Date.now() })
		}).catch(err => {
		  console.error("Error", err);
		});			
		navigate('/Workflow_Step_Definition',{replace:true});
	}
	if(location.hash=="#New"){
		setApp_Data({ ...App_Data});
		navigate('/Workflow_Step_Definition',{replace:true});
	}
	if(location.hash=="#Search"){
		setApp_Data({ ...App_Data});
		navigate('/Workflow_Step_Definition_S',{replace:true});
	}
	if(location.hash=="#Update"){
		setApp_Data({ ...App_Data});
		navigate('/Workflow_Step_Definition',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setApp_Data({ ...App_Data});
		navigate('/Workflow_Step_Definition_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setApp_Data({ ...App_Data});
		navigate('/Workflow_Step_Definition_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setApp_Data({ ...App_Data});
		navigate('/Workflow_Step_Definition_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		setApp_Data({ ...App_Data});
		navigate('/Workflow_Step_Definition',{replace:true});
	}
	if(location.hash=="#Export"){
		setApp_Data({ ...App_Data});
		navigate('/Workflow_Step_Definition',{replace:true});
	}
	if(location.hash=="#Import"){
		setApp_Data({ ...App_Data});
		navigate('/Workflow_Step_Definition',{replace:true});
	}
	if(location.hash=="#Help"){
		setApp_Data({ ...App_Data});
		navigate('/Workflow_Step_Definition',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setApp_Data({ ...App_Data});
		navigate('/Workflow_Step_Definition',{replace:true});
	}

     	    window.DataTableScript('#Table9');

  })  

  const [WORKFLOW_STEP_DEFINITION, setWORKFLOW_STEP_DEFINITION] = React.useState(null);
  const [WORKFLOW_STEP_DEFINITION_S, setWORKFLOW_STEP_DEFINITION_S] = React.useState(null);

  var Ids = [];
  for(var Ele in WORKFLOW_STEP_DEFINITION_S){
	  for(var Sec in WORKFLOW_STEP_DEFINITION_S[Ele]){
			if(Sec == "id")
				Ids.push(WORKFLOW_STEP_DEFINITION_S[Ele]["id"]);
			else if(Sec == "status")
				Ids.push(WORKFLOW_STEP_DEFINITION_S[Ele]["status"]);
			else if(Array.isArray(WORKFLOW_STEP_DEFINITION_S[Ele][Sec]))
				  for(var Row in WORKFLOW_STEP_DEFINITION_S[Ele][Sec])
					for (var Id in Row) 
						Ids.push(Id);
			else
				for (var Id in WORKFLOW_STEP_DEFINITION_S[Ele][Sec]) 
					Ids.push(Id);
	  }
  }
  
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
    axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/WORKFLOW_STEP_DEFINITION`).then((response) => {
      setWORKFLOW_STEP_DEFINITION(response.data);
	  
		var Temp_Detail = [];
		Object.keys(response.data).map((key, index) => {
		  var Temp_Obj={};
		  var Temp_Val = JSON.parse(JSON.stringify(response.data[index]));
		  for(var Sec in Temp_Val){
		     if(Sec == "id")
						Temp_Obj["id"] = Temp_Val[Sec];
			 else if(Array.isArray(Temp_Val[Sec])){
					  for(var Row in Temp_Val[Sec])
						for (var Id in Temp_Val[Sec][Row]){ 
							if(Temp_Obj.hasOwnProperty(Id))
								Temp_Obj[Id] += "|||"+Temp_Val[Sec][Row][Id];
							else
								Temp_Obj[Id]=Temp_Val[Sec][Row][Id];
						}
			}else{
				for (var Id in Temp_Val[Sec]){ 
					Temp_Obj[Id] = Temp_Val[Sec][Id];
				}
			}
		  }
		  Temp_Detail.push(Temp_Obj);
	  })
	  //setALLFIELDS_S(JSON.parse(JSON.stringify(Temp_Detail)));	  

	setWORKFLOW_STEP_DEFINITION_S(JSON.parse(JSON.stringify(Temp_Detail)));
	  
	  
	  
    });
	//$('#navbarNav1').show();
//$('#navbarNav6').show();

  }, []);

  if (!WORKFLOW_STEP_DEFINITION_S) return <div>Loading...</div>;

 const handleLastDataWORKFLOW_STEP_DEFINITION_S = async (data) => {
  };




  const handleAddWORKFLOW_STEP_DEFINITION_S = async () => {
    try {
      await axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/WORKFLOW_STEP_DEFINITION_S', JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION_S)));

      const response = await axios.get('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/WORKFLOW_STEP_DEFINITION_S');
      setWORKFLOW_STEP_DEFINITION_S(response.data);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
  

    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION_S));
	Temp_Data["1"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_0"]=value;
	//handleAddWORKFLOW_STEP_DEFINITION_S(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION_S']);
	Form_Data_onChange("1","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_0",value,Temp_Data);
 	//handleLastDataWORKFLOW_STEP_DEFINITION_S(Temp_Data);
    setWORKFLOW_STEP_DEFINITION_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION_S));
	Temp_Data["1"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_1"]=value;
	//handleAddWORKFLOW_STEP_DEFINITION_S(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION_S']);
	Form_Data_onChange("1","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_1",value,Temp_Data);
 	//handleLastDataWORKFLOW_STEP_DEFINITION_S(Temp_Data);
    setWORKFLOW_STEP_DEFINITION_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION_S));
	Temp_Data["1"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_2"]=value;
	//handleAddWORKFLOW_STEP_DEFINITION_S(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION_S']);
	Form_Data_onChange("1","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_2",value,Temp_Data);
 	//handleLastDataWORKFLOW_STEP_DEFINITION_S(Temp_Data);
    setWORKFLOW_STEP_DEFINITION_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION_S));
	Temp_Data["1"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_3"]=value;
	//handleAddWORKFLOW_STEP_DEFINITION_S(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION_S']);
	Form_Data_onChange("1","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_3",value,Temp_Data);
 	//handleLastDataWORKFLOW_STEP_DEFINITION_S(Temp_Data);
    setWORKFLOW_STEP_DEFINITION_S(Temp_Data);
 }; 
  

const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION));
	Temp_Data["2"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_0"]=value;
	Form_Data_onChange("2","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_0",value,Temp_Data);
 	//handleLastDataWORKFLOW_STEP_DEFINITION(Temp_Data);
    setWORKFLOW_STEP_DEFINITION(Temp_Data);
	//handleAddWORKFLOW_STEP_DEFINITION(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION']);
  }; 
  


const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION));
	Temp_Data["2"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_1"]=value;
	Form_Data_onChange("2","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_1",value,Temp_Data);
 	//handleLastDataWORKFLOW_STEP_DEFINITION(Temp_Data);
    setWORKFLOW_STEP_DEFINITION(Temp_Data);
	//handleAddWORKFLOW_STEP_DEFINITION(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION']);
  }; 
  


const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION));
	Temp_Data["2"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_2"]=value;
	Form_Data_onChange("2","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_2",value,Temp_Data);
 	//handleLastDataWORKFLOW_STEP_DEFINITION(Temp_Data);
    setWORKFLOW_STEP_DEFINITION(Temp_Data);
	//handleAddWORKFLOW_STEP_DEFINITION(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION']);
  }; 
  

    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION_S));
	Temp_Data["2"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_3"]=value;
	//handleAddWORKFLOW_STEP_DEFINITION_S(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION_S']);
	Form_Data_onChange("2","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_3",value,Temp_Data);
 	//handleLastDataWORKFLOW_STEP_DEFINITION_S(Temp_Data);
    setWORKFLOW_STEP_DEFINITION_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION_S));
	Temp_Data["2"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_4"]=value;
	//handleAddWORKFLOW_STEP_DEFINITION_S(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION_S']);
	Form_Data_onChange("2","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_4",value,Temp_Data);
 	//handleLastDataWORKFLOW_STEP_DEFINITION_S(Temp_Data);
    setWORKFLOW_STEP_DEFINITION_S(Temp_Data);
 }; 
  

const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION));
	Temp_Data["3"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_0"]=value;
	Form_Data_onChange("3","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_0",value,Temp_Data);
 	//handleLastDataWORKFLOW_STEP_DEFINITION(Temp_Data);
    setWORKFLOW_STEP_DEFINITION(Temp_Data);
	//handleAddWORKFLOW_STEP_DEFINITION(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION']);
  }; 
  

    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION_S));
	Temp_Data["3"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_1"]=value;
	//handleAddWORKFLOW_STEP_DEFINITION_S(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION_S']);
	Form_Data_onChange("3","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_1",value,Temp_Data);
 	//handleLastDataWORKFLOW_STEP_DEFINITION_S(Temp_Data);
    setWORKFLOW_STEP_DEFINITION_S(Temp_Data);
 }; 
  
  
      
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_2_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION_S));
	Temp_Data["3"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_2"]=value ? true : false; // optionally just use boolean
	//handleAddWORKFLOW_STEP_DEFINITION_S(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION_S']);
	Form_Data_onChange("3","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_2",value,Temp_Data);
 	//handleLastDataWORKFLOW_STEP_DEFINITION_S(Temp_Data);
    setWORKFLOW_STEP_DEFINITION_S(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_3_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION_S));
	Temp_Data["3"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_3"]=value ? true : false; // optionally just use boolean
	//handleAddWORKFLOW_STEP_DEFINITION_S(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION_S']);
	Form_Data_onChange("3","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_3",value,Temp_Data);
 	//handleLastDataWORKFLOW_STEP_DEFINITION_S(Temp_Data);
    setWORKFLOW_STEP_DEFINITION_S(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_4_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION_S));
	Temp_Data["3"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_4"]=value ? true : false; // optionally just use boolean
	//handleAddWORKFLOW_STEP_DEFINITION_S(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION_S']);
	Form_Data_onChange("3","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_4",value,Temp_Data);
 	//handleLastDataWORKFLOW_STEP_DEFINITION_S(Temp_Data);
    setWORKFLOW_STEP_DEFINITION_S(Temp_Data);
 }; 
  


    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION_S));
	Temp_Data["4"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_4_0"]=value;
	//handleAddWORKFLOW_STEP_DEFINITION_S(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION_S']);
	Form_Data_onChange("4","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_4_0",value,Temp_Data);
 	//handleLastDataWORKFLOW_STEP_DEFINITION_S(Temp_Data);
    setWORKFLOW_STEP_DEFINITION_S(Temp_Data);
 }; 
  

const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_4_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION));
	Temp_Data["4"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_4_1"]=value;
	Form_Data_onChange("4","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_4_1",value,Temp_Data);
 	//handleLastDataWORKFLOW_STEP_DEFINITION(Temp_Data);
    setWORKFLOW_STEP_DEFINITION(Temp_Data);
	//handleAddWORKFLOW_STEP_DEFINITION(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION']);
  }; 
  


const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION));
	Temp_Data["9"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_0"]=value;
	Form_Data_onChange("9","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_0",value,Temp_Data);
 	//handleLastDataWORKFLOW_STEP_DEFINITION(Temp_Data);
    setWORKFLOW_STEP_DEFINITION(Temp_Data);
	//handleAddWORKFLOW_STEP_DEFINITION(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION']);
  }; 
  

    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION_S));
	Temp_Data["9"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_1"]=value;
	//handleAddWORKFLOW_STEP_DEFINITION_S(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION_S']);
	Form_Data_onChange("9","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_1",value,Temp_Data);
 	//handleLastDataWORKFLOW_STEP_DEFINITION_S(Temp_Data);
    setWORKFLOW_STEP_DEFINITION_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION_S));
	Temp_Data["9"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_2"]=value;
	//handleAddWORKFLOW_STEP_DEFINITION_S(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION_S']);
	Form_Data_onChange("9","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_2",value,Temp_Data);
 	//handleLastDataWORKFLOW_STEP_DEFINITION_S(Temp_Data);
    setWORKFLOW_STEP_DEFINITION_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION_S));
	Temp_Data["9"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_3"]=value;
	//handleAddWORKFLOW_STEP_DEFINITION_S(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION_S']);
	Form_Data_onChange("9","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_3",value,Temp_Data);
 	//handleLastDataWORKFLOW_STEP_DEFINITION_S(Temp_Data);
    setWORKFLOW_STEP_DEFINITION_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION_S));
	Temp_Data["9"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_4"]=value;
	//handleAddWORKFLOW_STEP_DEFINITION_S(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION_S']);
	Form_Data_onChange("9","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_4",value,Temp_Data);
 	//handleLastDataWORKFLOW_STEP_DEFINITION_S(Temp_Data);
    setWORKFLOW_STEP_DEFINITION_S(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID) => {

};


 
   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
	selectedData = WORKFLOW_STEP_DEFINITION_S.find(e => e.id == selectedRowId);
    //App_Data.Return_Data=selectedRowId;
    App_Data.Object_Return=selectedRowId;
    //console.log(event.currentTarget.querySelector('td').textContent);
    App_Data.Object_Text=selectedRowId+";"+event.currentTarget.querySelector('td').textContent;
    App_Data.Object_Id=selectedRowId;
	App_Data.Data=selectedData;
	setApp_Data({ ...App_Data})
    window.location.hash = 'Return';
   };
 
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
			  {t('Select Workflow Step Definition')}
			  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
			</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item">
					  <a id="navbarNav1" className="nav-link" href="#Return">{t(`Return`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>		 
         {/* Search Fields*/}
         <div className="container-fluid mt-5">
            <h2  id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Advanced Search`)} <span className="toggle-icon">v</span></h2>
            <div  id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Workflow Step ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_0" type="text" className="form-control" placeholder="Workflow Step ID"  
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Workflow Step ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Workflow ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_1" type="text" className="form-control" placeholder="Workflow ID"  
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Workflow ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '50ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Step Number`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_2" type="text" className="form-control" placeholder="Step Number"  
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '50ch' }}>
						 {t(`Enter Step Number`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '120ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Step Name`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_3" type="text" className="form-control" placeholder="Step Name"  
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '120ch' }}>
						 {t(`Enter Step Name`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Step IO Mapping Type`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_0"   onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_0_Change} className="form-control" name="Step IO Mapping Type"  >
						  <option value="Input Form">Input Form</option>
						  <option value="Output Form">Output Form</option>
						  <option value="Responsible Role">Responsible Role</option>
						  <option value="Notification Target">Notification Target</option>
						  <option value="Escalation Target">Escalation Target</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Step IO Mapping Type
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Responsible Stakeholder Type`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_1"   onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_1_Change} className="form-control" name="Responsible Stakeholder Type"  >
						  <option value="Platform Admin">Platform Admin</option>
						  <option value="Project Owner">Project Owner</option>
						  <option value="Developer">Developer</option>
						  <option value="Property Manager">Property Manager</option>
						  <option value="Inspector">Inspector</option>
						  <option value="Appraiser">Appraiser</option>
						  <option value="Title Company">Title Company</option>
						  <option value="Escrow Agent">Escrow Agent</option>
						  <option value="Legal Counsel">Legal Counsel</option>
						  <option value="Broker-Dealer">Broker-Dealer</option>
						  <option value="Transfer Agent">Transfer Agent</option>
						  <option value="Investor">Investor</option>
						  <option value="Auditor">Auditor</option>
						  <option value="Contractor">Contractor</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Responsible Stakeholder Type
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Responsible Role`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_2"   onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_2_Change} className="form-control" name="Responsible Role"  >
						  <option value="Submitter">Submitter</option>
						  <option value="Reviewer">Reviewer</option>
						  <option value="Approver">Approver</option>
						  <option value="Verifier">Verifier</option>
						  <option value="Signer">Signer</option>
						  <option value="Observer">Observer</option>
						  <option value="Escalation Owner">Escalation Owner</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Responsible Role
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '100ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Input Form Table`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_3" type="text" className="form-control" placeholder="Input Form Table"  
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '100ch' }}>
						 {t(`Enter Input Form Table`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '100ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Output Form Table`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_4" type="text" className="form-control" placeholder="Output Form Table"  
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '100ch' }}>
						 {t(`Enter Output Form Table`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Approval Rule Type`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_0"   onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_0_Change} className="form-control" name="Approval Rule Type"  >
						  <option value="Standard Approval">Standard Approval</option>
						  <option value="Dual Approval">Dual Approval</option>
						  <option value="Compliance Approval">Compliance Approval</option>
						  <option value="Legal Approval">Legal Approval</option>
						  <option value="Escalation Rule">Escalation Rule</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Approval Rule Type
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '100ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approval Form Table`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_1" type="text" className="form-control" placeholder="Approval Form Table"  
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '100ch' }}>
						 {t(`Enter Approval Form Table`)}
                     </div>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_2" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Can Reject`)} <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_2" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_2_Change} 
					  checked={WORKFLOW_STEP_DEFINITION_S?.["3"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_2"] === "true" || WORKFLOW_STEP_DEFINITION_S?.["3"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_2"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_3" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Can Request Revision`)} <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_3" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_3_Change} 
					  checked={WORKFLOW_STEP_DEFINITION_S?.["3"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_3"] === "true" || WORKFLOW_STEP_DEFINITION_S?.["3"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_3"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_4" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Blocks Next Step`)} <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_4" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_4_Change} 
					  checked={WORKFLOW_STEP_DEFINITION_S?.["3"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_4"] === "true" || WORKFLOW_STEP_DEFINITION_S?.["3"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_4"] === true} />
					</label>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '50ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Step SLA Days`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_4_0" type="text" className="form-control" placeholder="Step SLA Days"  
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_4_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_4_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '50ch' }}>
						 {t(`Enter Step SLA Days`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Escalation Role`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_4_1"   onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_4_1_Change} className="form-control" name="Escalation Role"  >
						  <option value="Operations Manager">Operations Manager</option>
						  <option value="Compliance Officer">Compliance Officer</option>
						  <option value="Legal Counsel">Legal Counsel</option>
						  <option value="Chief Risk Officer">Chief Risk Officer</option>
						  <option value="Platform Administrator">Platform Administrator</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Escalation Role
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_0"   onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_1" type="text" className="form-control" placeholder="Created By"  
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_2" type="text" className="form-control" placeholder="Created At"  
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_3" type="text" className="form-control" placeholder="Updated By"  
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_4" type="text" className="form-control" placeholder="Updated At"  
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
		 {/* Query Result*/}
         <div className="container-fluid mt-5">
            <h2 style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Query Result`)}</h2>
            <div className="row">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('9')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table9" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`Workflow Step ID`)}</th>
                        <th>{t(`Workflow ID`)}</th>
                        <th>{t(`Step Number`)}</th>
                        <th>{t(`Step Name`)}</th>
                        <th>{t(`Step IO Mapping Type`)}</th>
                        <th>{t(`Responsible Stakeholder Type`)}</th>
                        <th>{t(`Responsible Role`)}</th>
                        <th>{t(`Input Form Table`)}</th>
                        <th>{t(`Output Form Table`)}</th>
                        <th>{t(`Approval Rule Type`)}</th>
                        <th>{t(`Approval Form Table`)}</th>
                        <th>{t(`Can Reject`)}</th>
                        <th>{t(`Can Request Revision`)}</th>
                        <th>{t(`Blocks Next Step`)}</th>
                        <th>{t(`Step SLA Days`)}</th>
                        <th>{t(`Escalation Role`)}</th>
                        <th>{t(`Record Status`)}</th>
                        <th>{t(`Created By`)}</th>
                        <th>{t(`Created At`)}</th>
                        <th>{t(`Updated By`)}</th>
                        <th>{t(`Updated At`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {WORKFLOW_STEP_DEFINITION_S.map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_0"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_1"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_2"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_3"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_0"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_1"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_2"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_3"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_4"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_0"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_1"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_2"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_3"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_4"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_4_0"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_4_1"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_0"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_1"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_2"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_3"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_4"]} </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
  </>;
};

export default Workflow_Step_Definition_S;  